import { useAuthListUser } from "stores/hooks/auth";
import { StyledLabel, StyledUserStatus } from "./user-status.styles";
import { useTranslate } from "stores/hooks/translation";

const UserStatus = () => {
  const translate = useTranslate();
  const listUser = useAuthListUser();

  if (!listUser) {
    return null;
  }

  return (
    <StyledUserStatus>
      <StyledLabel>{translate("user_status")}:</StyledLabel>&nbsp;
      {translate(`user_status_${listUser.status}`)}
    </StyledUserStatus>
  );
};

export default UserStatus;
